export const environment = {
  production: false,
  // url: 'https://api.loadboardnetwork.com/api' //Prod
  url: 'https://api-dev.loadboardnetwork.com/api', // DEV
  socketUrl: "https://api-dev.loadboardnetwork.com",
  analyticsAPI: 'https://analytics.loadboardnetwork.com/api/v1/dev',
};